import { defineStore } from 'pinia';

interface ProductSuggestionsState {
  drawerOpen: boolean;
  productId?: number;
}

export const useProductSuggestionsStore = defineStore('productSuggestions', {
  state: (): ProductSuggestionsState => ({
    drawerOpen: false,
    productId: undefined,
  }),
  getters: {},
  actions: {
    closeDrawer() {
      this.drawerOpen = false;
    },
    openDrawer() {
      this.drawerOpen = true;
    },
    toggleDrawer() {
      this.drawerOpen = !this.drawerOpen;
    },
    setProductId(productId: number) {
      this.productId = productId;
    },
  },
});
